import PropTypes from "prop-types";
import { StyledStatus } from "../../styles/StyledStatus";

export default function Status({ status = "ongoing" }) {
	return <StyledStatus status={status}></StyledStatus>;
}

Status.propTypes = {
	status: PropTypes.string,
};
